import { BaseRequest } from './BaseRequest';

export class AiStudioAgentPlanRequest extends BaseRequest {
    TenantId: string | null;
    PlanId: string | null;
    BlockedFrom: Date | null;
    BlockedUntil: Date | null;

    constructor() {
        super();
        this.TenantId = null;
        this.PlanId = null;
        this.BlockedFrom = null;
        this.BlockedUntil = null;
    }
}